// extracted by mini-css-extract-plugin
export default {"dropzone":"dropzoneField_dropzone__XbAyv","chooseFileMessage":"dropzoneField_chooseFileMessage__ZUhcd","errorTitle":"dropzoneField_errorTitle__RddIG"};